import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';

import { WidgetComponent } from '../';
import { DashboardService } from 'core/index';

@Component({
  selector: 'lms-historic-widget',
  templateUrl: './historic-widget.component.html',
  styleUrls: ['./historic-widget.component.scss'],
  host: { class: 'dashboard-widget' }
})
export class HistoricWidgetComponent implements WidgetComponent, OnInit, OnDestroy {
  @Input() data: any;
  public totalGroups: any;
  public ratioFinished: any;
  public ratioRecommendation: any;
  public ratioApplication: any;
  public dataSubscription: Subscription;

  constructor(public dashboardService: DashboardService) {}

  ngOnInit() {
    const clientId = this.data.clientId;
    this.dataSubscription = this.dashboardService.loadData(this.data.clientId).subscribe((data) => {
      // Ignore data coming from other clients
      if (data && data._id && data._id !== clientId) {
        return;
      }

      this.totalGroups = `${data && data.totalGroups ? data.totalGroups : 0}`;
      this.ratioFinished = `${data && data.ratioFinished ? data.ratioFinished : 0}%`;
      this.ratioRecommendation = `${data && data.ratioRecommendation ? data.ratioRecommendation : 0}%`;
      this.ratioApplication = `${data && data.ratioApplication ? data.ratioApplication : 0}%`;
    });
  }

  ngOnDestroy() {
    this.dataSubscription.unsubscribe();
  }
}
